import { useQuery } from 'react-fetching-library';
import { useSelector } from 'react-redux';

import selectors from '../../store/selectors';

const fetchDonationPurposes = accountId => ({
  method: 'GET',
  endpoint: `/api/donate/accounts/${accountId}/donations/purposes`,
});

export const useFetchDonationPurposes = () => {
  const accountId = useSelector(selectors.getAccountId);

  const { loading, payload, error } = useQuery(fetchDonationPurposes(accountId));

  return { loading, payload, error };
};
